module.exports = __webpack_public_path__ + "static/media/maf-38.970ffb93.png";